<template>
  <div class="a-accordion__collapse ">
    <div class="a-accordion__tab" v-for="item in records">
      <div class="a-accordion__btn-tab ">
        <div class="a-accordion__label a-accordion__label--open a-width-100-percent"  >
          <div class="a-width-100-percent a-container-form">
            <div class="a-width-100-percent a-container-form">
              <div class="a-form-field a-width-100-percent" v-if="item.editable">
                <input type="text" class="a-input a-width-100-percent" v-model="item.name" @keyup.enter="onConfirmClick(item)">
                <span class="a-helper-text a-validation-error" v-if="item.error">{{$t('labels.mandatory-field')}}</span>
              </div>
              <span v-else class="a-width-100-percent"><b>{{item.name}}</b></span>
            </div>

            <template v-if="item.editable">
              <span class="a-container-form">
                <button class="a-accordion__editing-btn" @click.prevent="onConfirmClick(item)">
                  <img src="@/assets/img/static/tab-ok.svg">
                </button>
                <button class="a-accordion__editing-btn" @click.prevent="onCancelClick(item)">
                  <img src="@/assets/img/static/tab-close.svg">
                </button>
              </span>
            </template>

            <template v-else>
              <span class="a-container-form">
                <button class="a-accordion__editing-btn" @click.prevent="$emit('editItem', item)">
                  <img src="@/assets/img/static/b-icon_edit.svg" alt="">
                  {{$t('form.catalogs.catalog-type.accreditations.modify')}}
                </button>
                <button class="a-accordion__remove-btn" @click.prevent="$emit('deleteItem', item)">
                  <img src="@/assets/img/static/trashcan.svg">
                </button>
              </span>
            </template>
          </div>

          <div v-if="item.editable" class="a-filter__block-checkbox a-checkbox">
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" v-model="item.organization">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text" v-t="'form.catalogs.catalog-type.accreditations.required-document-for-organization'"></span>
            </label>
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" v-model="item.ip">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text" v-t="'form.catalogs.catalog-type.accreditations.required-document-for-ip'"></span>
            </label>
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" v-model="item.person">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text" v-t="'form.catalogs.catalog-type.accreditations.required-document-for-person'"></span>
            </label>
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" v-model="item.passport">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text" v-t="'form.catalogs.catalog-type.accreditations.trusted-document'"></span>
            </label>
          </div>
          <div v-else>
            <div class="a-container-form ">
              <div class="a-label ">{{$t('labels.organization-type')}}:</div>
              <div class="a-input a-input--disabled u-width-100">
                <p class="a-input a-input--disabled ">{{types(item)}}</p>
              </div>
            </div>
            <div class="a-container-form ">
              <div class="a-label a-label--auto">{{$t('form.catalogs.catalog-type.accreditations.trusted-document')}}:</div>
              <div class="a-input a-input--disabled">
                <p class="a-input a-input--disabled ">{{$t(item.passport ? 'labels.yes' : 'labels.no')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from '@/validators'

  export default {
    name: 'AccreditationsCatalogLevel',

    props: {
      documents: Array,
      isNew: Boolean
    },

    computed: {
      records() {
        return this.documents;
      }
    },

    methods: {
      types(item) {
        const values = [];

        if (item.organization) {
          values.push(this.$t('org-type.organization'))
        }

        if (item.ip) {
          values.push(this.$t('org-type.ip'))
        }

        if (item.person) {
          values.push(this.$t('org-type.person'))
        }

        return values.join(', ');
      },

      onConfirmClick(item) {
        if (!required(item.name)) {
          this.$set(item, 'error', true);
          return;
        }

        this.$set(item, 'error', false);
        this.$emit('confirmEditable', item);
      },

      onCancelClick(item) {
        this.$emit('cancelEditable', item);
      }
    }
  }
</script>

<style scoped>

</style>
